import {
  Button,
  Flex,
  Heading,
  Icon,
  Image,
  Link,
  ListItem,
  Stack,
  Text,
  UnorderedList,
  useColorModeValue,
} from '@chakra-ui/react';
import { motion } from 'framer-motion';
import React, { useEffect, useState } from 'react';
import AnimatedPage from '../components/Other/AnimatedPage';
import { BsFileEarmarkCode } from 'react-icons/bs';
import { FiExternalLink } from 'react-icons/fi';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { Carousel } from 'react-responsive-carousel';
import  projectsData  from '../components/Data/ProjectsData';
import { useParams } from 'react-router-dom';
import NotFound from './NotFound';

const ProjectInfoPage = () => {
  const [project, setProject] = useState(null);
  const underlineColor = useColorModeValue(
    'rgb(64,64,64,0.6)',
    'rgb(255,255,255,0.6)'
  );
  let delay = 0;

  let { projectId } = useParams();

  useEffect(() => {
    const array = projectsData.filter(
      (project) => {
        return (
      project.id === parseInt(projectId)
    )}
    );
    if (array.length > 0) {
    setProject({ ...array[0] });
    } 
  }, [projectId]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  

  return (
    <AnimatedPage>
      {project ?  
      <Flex minH={'66vh'} mb={'2rem'} mt={'4rem'} direction={'column'}>
        <Heading
          pb={'15px'}
          mb={'20px'}
          borderBottom={`1px solid ${underlineColor}`}
        >
          {project?.title}
        </Heading>
        <Text whiteSpace={'pre-line'}>{project.description}</Text>
        <Heading textDecor={'underline'} size={'lg'} mt={'2rem'} mb={'1rem'}>
          Technologies
        </Heading>
        <Flex>
          {project?.technologies?.map((tech, index) => {
            return (
              <Flex
                key={index}
                as={motion.div}
                initial={{ opacity: 0, scale: 0, x: -100 }}
                animate={{ opacity: 1, scale: 1, x: 0 }}
                transition={` 1s ${(delay += 0.2)}s`}
                direction={'column'}
                alignItems={'center'}
              >
                <Image
                  mb={'8px'}
                  src={tech.src}
                  w={['60%', '60%', '60%', '70%', '70%']}
                  maxH={'70px'}
                ></Image>
                <Text
                  fontWeight={'semibold'}
                  letterSpacing={'2px'}
                  fontFamily={'montseratt, sans-serif'}
                  fontSize={['8px', '8px', '8px', '8px']}
                >
                  {tech.name}
                </Text>
              </Flex>
            );
          })}
        </Flex>
        {project.features &&
        <Heading textDecor={'underline'} size={'lg'} mt={'1rem'} mb={'1rem'}>
          Features
        </Heading>
        }
        { project?.features?.general &&
        <>
        <Heading mb={'10px'} size={'md'}>General:</Heading>
        <UnorderedList>
          {project?.features?.general?.map((feature, index) => {return (
          <ListItem key={index}>{feature}</ListItem>
          )})}
        </UnorderedList>
        </>
}
        { project?.features?.frontend &&
        <>
        <Heading mb={'10px'} size={'md'}>{project.features.backend ? 'Frontend:' : ''}</Heading>
        <UnorderedList>
          {project?.features?.frontend?.map((feature, index) => {return (
          <ListItem key={index}>{feature}</ListItem>
          )})}
        </UnorderedList>
        </>
}
{ project?.features?.backend &&
        <>
        <Heading my={'10px'} size={'md'}>Backend:</Heading>
        <UnorderedList>
          {project?.features?.backend.map((feature, index) => {return (
          <ListItem key={index}>{feature}</ListItem>
          )})}
        </UnorderedList>
        </>
}
{ project?.features?.technicalities &&
        <>
        <Heading my={'10px'} size={'md'}>Technicalities:</Heading>
        <UnorderedList>
          {project?.features?.technicalities.map((feature, index) => {return (
          <ListItem key={index}>{feature}</ListItem>
          )})}
        </UnorderedList>
        </>
}
        <Heading textDecor={'underline'} size={'lg'} mt={'1rem'} mb={'1rem'}>
          Code And Demo
        </Heading>
        <Flex wrap={'wrap'}>
          <Stack direction={'row'} spacing={8}>
            {
            <Link as={'a'} href={project.codeUrl ? project.codeUrl : project.frontendCodeUrl} target="_blank" isExternal>
              <Button _hover={{backgroundColor: 'blue.700'}} backgroundColor={'#4c7dcb'} size={['xs', 'sm']}>
                <Icon mr={'5px'} as={BsFileEarmarkCode}></Icon>{project.frontendCodeUrl ? 'Frontend' : 'GitHub'}
              </Button>
            </Link>
}
            {project.backendCodeUrl &&
            <Link as={'a'} href={project?.backendCodeUrl} target="_blank" isExternal>
            <Button _hover={{backgroundColor: 'green.800'}} backgroundColor={'green.600'} size={['xs', 'sm']}>
              <Icon mr={'5px'} as={BsFileEarmarkCode}></Icon>Backend
            </Button>
          </Link>
            }
            {project?.demoUrl &&
              <Link as={'a'} href={project?.demoUrl} target="_blank" isExternal>
              <Button backgroundColor={'orange.600'} size={['xs', 'sm']} _hover={{backgroundColor: 'orange.700'}}>
                <Icon mr={'5px'} as={FiExternalLink}></Icon> Demo
              </Button>
            </Link>
            }
            
          </Stack>
        </Flex>
        <Heading textDecor={'underline'} size={'lg'} mt={'1rem'} mb={'1rem'}>
          Media
        </Heading>
        <Carousel dynamicHeight={(project.id === 6) ? true : false}>
          { project?.media?.map((mediaUrl, index) => {return (
          <img key={index} src={mediaUrl} alt="" style={{objectFit:'contain',  maxHeight:'500px'}}/>
          )})
}
        </Carousel>
      </Flex>
 :
 <NotFound/>
 }
    </AnimatedPage>
  );
};

export default ProjectInfoPage;
